export const selectProtectiveEquipmentType = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-protective-equipment-type.html'),
    controller: 'SelectProtectiveEquipmentTypeController'
};
